module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-section"
  }, [_c('div', {
    staticClass: "ds-header"
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.icon))]), _vm._v(" "), _c('span', {
    staticClass: "ds-title"
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), (_vm.viewMode === 'grid') ? _c('dashboard-project-grid', {
    attrs: {
      "projects": _vm.projects
    },
    on: {
      "projectAccepted": function($event) {
        return _vm.$emit('projectAccepted', $event)
      },
      "projectDeleted": function($event) {
        return _vm.$emit('projectDeleted', $event)
      }
    }
  }) : _c('dashboard-list', {
    attrs: {
      "projects": _vm.projects,
      "sort": _vm.sort
    },
    on: {
      "sortChange": function($event) {
        return _vm.$emit('sortChange', $event)
      },
      "projectAccepted": function($event) {
        return _vm.$emit('projectAccepted', $event)
      },
      "projectDeleted": function($event) {
        return _vm.$emit('projectDeleted', $event)
      }
    }
  }), _vm._v(" "), (_vm.showViewMore) ? _c('div', {
    staticClass: "ds-more"
  }, [(!_vm.loadingMore) ? _c('a', {
    staticClass: "ds-view-more",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('viewMore')
      }
    }
  }, [_vm._v("View more")]) : _c('span', {
    staticClass: "ds-loading"
  }, [_vm._v("Loading…")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6db42a24","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/dashboard-section.vue
// module id = 1259
// module chunks = 21